import { alpha, Theme } from '@mui/material'

// ----------------------------------------------------------------------

// A shadow is an absence of light, so it is built on true black. `grey[900]`
// is the neutral ramp's ink and is near white in dark mode, which turned the
// drawer's drop shadow into a glow.
export default function Drawer(theme: Theme) {
  const isLight = theme.palette.mode === 'light'

  return {
    MuiDrawer: {
      styleOverrides: {
        modal: {
          '&[role="presentation"]': {
            '& .MuiDrawer-paperAnchorLeft': {
              boxShadow: `8px 24px 24px 12px ${alpha(
                theme.palette.common.black,
                isLight ? 0.16 : 0.48,
              )}`,
            },
            '& .MuiDrawer-paperAnchorRight': {
              boxShadow: `-8px 24px 24px 12px ${alpha(
                theme.palette.common.black,
                isLight ? 0.16 : 0.48,
              )}`,
            },
          },
        },
      },
    },
  }
}
